var loadPosts = {
	selectors: {
		button: '[load-more-posts]',
	},
	emailAllow: '@gmail.com',
	init: function () {
		var self = this;

		jQuery(self.selectors.button).on('click', function (event) {
			event.preventDefault();

			if ($(this).attr('load-more-posts') != '') {
				self.ajaxLoad($(this), $(this).attr('load-more-posts'), $(this).attr('current-load'));
			}
		});
	},
	ajaxLoad(button, attr, load) {
		var self = this;

		jQuery.ajax({
			type: 'POST',
			url: themeVars.ajax_url,
			data: {
				action: 'load_posts',
				attr: attr,
				load: load,
			},
			success: function (response) {
				if (response['data']['can_load'] === false) {
					button.addClass('hide');
				}

				var loaded = parseInt(load) + parseInt(response['data']['count']);
				button.attr('current-load', loaded);

				var posts = response['data']['posts'].join();
				var prependBefore = button.parent().parent().find('[load-items-before-thus]');
				jQuery(posts).insertBefore(prependBefore);
			},
			error: function (errorThrown) {
				console.log(errorThrown);
			},
		});
	},
};

export { loadPosts };
